import { CHANNEL_TYPE, CHANNEL_TYPES_OBJECT } from '../../../../enum/constants';

export interface ChannelTariff {
  name: string;
  key: CHANNEL_TYPE;
  price: number;
  max?: number;
  count?: number;
  disabled?: boolean;
  connected_count?: number;
  currentPrice?: number;
  prev_count?: number;
  free_count?: number;

}

/** Tariffs without the "additional channels" tab: they choose the channel count while paying the tariff */
export const UNPAID_TARIFFS = ['trial', 'demo', 'free'];

export interface PaymentPeriod {
  months: number;
  discount: number;
}

export const PAYMENT_PERIODS: PaymentPeriod[] = [
  { months: 1, discount: 0 },
  { months: 3, discount: 10 },
];

/** OLX costs less per channel the more channels there are; `upTo: null` is the last tier */
export const OLX_PRICE_TIERS: { upTo: number | null; price: number }[] = [
  { upTo: 20, price: 1 },
  { upTo: 60, price: 0.7 },
  { upTo: 100, price: 0.5 },
  { upTo: null, price: 0.3 },
];

/** Price of one channel a month for this many channels: the type price, OLX by its tiers */
export const getChannelUnitPrice = (channel: Pick<ChannelTariffClass, 'key' | 'price'>, count: number): number => {
  if (channel.key !== CHANNEL_TYPE.OLX) return channel.price;

  return (OLX_PRICE_TIERS.find((tier) => tier.upTo === null || count <= tier.upTo) ?? OLX_PRICE_TIERS[0]).price;
};

export const formatUsd = (amount: number): string =>
  (amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export class ChannelTariffClass {
  name!: string;
  key!: CHANNEL_TYPE;
  logo?: string;
  price!: number;
  max: number = 500;
  count: number = 0;
  connected_count: number = 0;
  prev_count: number = 0;
  disabled: boolean = false;
  currentPrice: number = 0;
  freeCount: number = 0;

  constructor({ name, key, price, max, connected_count, prev_count, count, disabled, free_count }: ChannelTariff) {
    this.name = name;
    this.key = key;
    this.logo = CHANNEL_TYPES_OBJECT[key]?.img_url;
    this.price = price;
    if (max) {
      this.max = max;
    }
    if (connected_count) {
      this.connected_count = connected_count;
    }
    if (prev_count) {
      this.prev_count = prev_count;
    }
    if (count) {
      this.count = count;
    }

    if (free_count) {
      this.freeCount = free_count;
    }
    this.disabled = !!disabled;
  }
}
